import { type Query, type Sort, BoolQuery, Highlight, RequestBodySearch } from 'elastic-builder';

export type ElasticRequest = Partial<{
  from: number;
  highlight: Highlight;
  query: BoolQuery;
  size: number;
  sorts: Sort[];
}>;

// eslint-disable-next-line complexity
export function createElasticData(requestData?: ElasticRequest, additionalFilter?: Query | Query[]) {
  const search = new RequestBodySearch();
  const query = requestData?.query ?? new BoolQuery();

  if (additionalFilter) {
    query.filter(additionalFilter);
  }

  search.query(query);

  search.size(requestData?.size ?? 10);

  if (requestData?.sorts) {
    search.sorts(requestData.sorts);
  }

  search.from(requestData?.from ?? 0);
  search.highlight(requestData?.highlight ?? new Highlight());

  return search.toJSON();
}
